import React, { createRef, JSX } from "react";
import getIngredients, { INGREDIENTS } from "./getIngredients.ts";
import type { AbstractCanvasProps } from "./abstractcanvas.tsx";
import SaveCanvas from "./saveCanvas.tsx";

interface AbstractChallengeState<D> {
    ingredients?: INGREDIENTS;
    currentChallengeData?: D;
}

function listToText(list: string[], conjunction: string) {
    if (list.length===0) {return undefined}
    if (list.length===1) {return list[0]}
    let lastItem=list.pop()
    return list.join(", ") + " "+ conjunction +" " + lastItem
}

function weightedRandomNumber(items: Record<number, number>): number {
  const entries = Object.entries(items) as [string, number][];
  const totalWeight = entries.reduce((sum, [, weight]) => sum + weight, 0);
  const rand = Math.random() * totalWeight;

  let cumulative = 0;
  for (const [key, weight] of entries) {
    cumulative += weight;
    if (rand < cumulative) {
      return Number(key);
    }
  }
  // Fallback (shouldn't happen if weights are valid)
  throw new Error("Invalid weights or empty input");
}

function weightedRandomString(items: Record<string, number>): string {
  const entries = Object.entries(items) as [string, number][];
  const totalWeight = entries.reduce((sum, [, weight]) => sum + weight, 0);
  const rand = Math.random() * totalWeight;

  let cumulative = 0;
  for (const [key, weight] of entries) {
    cumulative += weight;
    if (rand < cumulative) {
      return key;
    }
  }
  // Fallback (shouldn't happen if weights are valid)
  throw new Error("Invalid weights or empty input");
}

export abstract class AbstractChallenge<D> extends React.Component<{}, AbstractChallengeState<D>> {
    private canvasRef: React.RefObject<HTMLCanvasElement | null>;
    constructor(props: {}) {
        super(props);
        this.canvasRef = createRef();
        this.state = {
            ingredients: undefined,
            currentChallengeData: undefined
        }
        this.reloadCanvas = this.reloadCanvas.bind(this)
    }
    
    async componentDidMount() {
        let ingredients = await getIngredients()
        this.setState({ingredients}, this.reloadCanvas)
    }

    reloadCanvas() {
        if (this.state.ingredients){
            var ne = this.getChallengeData(this.state.ingredients);
            console.log(ne)
            this.setState({currentChallengeData: ne});
        }
    }

    getRandomInt(max: number): number {
        return Math.floor(Math.random() * max);
    }

    abstract getChallengeData(ingredients: INGREDIENTS): D;
    abstract title(): string;
    abstract reloadButtonText(): string;
    abstract canvas(props: AbstractCanvasProps<D>): JSX.Element | null;

    render() {
        console.log(this.state)
        return <div className="App">
        <div>
            <h2>{this.title()}</h2>
                {this.state.ingredients&&this.state.currentChallengeData?
                this.canvas({canvasRef:this.canvasRef, ingredients:this.state.ingredients, currentChallengeData: this.state.currentChallengeData})
                :null}
                <SaveCanvas canvasRef={this.canvasRef} />
                <button onClick={this.reloadCanvas}>{this.reloadButtonText()}</button>
                <a className="button-link" href="/">Homepage</a>
            </div>
        </div>
    }
}
export {listToText, weightedRandomNumber, weightedRandomString}
export type {AbstractChallengeState}